import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { fromEvent, skip } from 'rxjs';
import { BrowseService } from '../service/browse.service';

@Component({
  selector: 'app-browse-survey',
  templateUrl: './browse-survey.component.html',
  styleUrls: ['./browse-survey.component.scss']
})
export class BrowseSurveyComponent implements OnInit, AfterViewInit {
  public urlSafe!: SafeResourceUrl;
  @ViewChild("surveyIfrale", { static: false }) surveyIfrale :ElementRef | undefined
  public url:string='https://survey-dev.crownit.in/utg/123';
  // public urls:string[]=["https://survey-dev.crownit.in/utg/123"];
  public isUrlLoadedFirstTime:boolean=false;
  constructor(public sanitizer: DomSanitizer, public activatedRoute:ActivatedRoute, public browseService:BrowseService) { }

  ngOnInit(): void {
    this.isUrlLoadedFirstTime = false;
    // console.log(Math.random())
    this.activatedRoute.queryParams.subscribe(params => {
      this.browseService.surveyStart = params['start'];
      this.browseService.surveyEnd = (params['end'] && params['end'] != '')? params['end'] : params['start']
  }) 
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    // setTimeout(()=>{
    //   let url1 = 'https://api.mcollector.com/utg/123?gender=Female&age=34&city=Gurugram';
    //   this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(url1);
    // },3000)
  }

  ngAfterViewInit(): void {
    if (this.surveyIfrale) {
      fromEvent(this.surveyIfrale.nativeElement, 'load')
        // Skip the initial load event and only capture subsequent events.
        .pipe(skip(1))
        .subscribe(
            (event: any) => {
              console.log("event.target",event.target)
            }
          );
    }
}

  // onUrlChange(url:string){
  //   this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(url);
  //   if (this.browseService.surveyEnd && this.browseService.surveyEnd.toLowerCase() == url.toLowerCase()) {
  //     this.onFinaleSubmit();
  //   }
  // }

  onFinaleSubmit(){
    console.log("this is tha final submit")
  }

  onUrlChange(){
    // let url =urlSafe.changingThisBreaksApplicationSecurity
    // console.log(url)
    console.log(this.surveyIfrale?.nativeElement)
    console.log(this.surveyIfrale?.nativeElement.src)
   
    console.log("this.surveyIfrale?.nativeElement.contentWindow",this.surveyIfrale?.nativeElement.contentWindow)
    // document.getElementById("iframe_id").contentWindow.location.href

    // if (this.browseService.surveyEnd && this.browseService.surveyEnd.toLowerCase() == url.toLowerCase()) {
    //   this.onFinaleSubmit();
    // }

    this.isUrlLoadedFirstTime = true;
  }
  
}
